import { LOAD_LIKES, ADD_LIKE, REMOVE_LIKE } from "./types";

const initialState = {
  items: {},
  loading: true,
};

export default function likesReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_LIKES:
      return { items: action.payload, loading: false };
    case ADD_LIKE:
      return {
        ...state,
        items: { ...state.items, [action.payload.imdbID]: action.payload },
      };
    case REMOVE_LIKE: {
      const newItems = { ...state.items };
      delete newItems[action.payload];
      return { ...state, items: newItems };
    }
    default:
      return state;
  }
}
